import { css } from '@emotion/react'
import { EINA_01_FONT } from 'gin-and-tonic/utils/styling/fonts/eina01Font'
import { fontSize, defaultLineHeight } from 'gin-and-tonic/foundation/fontSize'
import { colors } from 'gin-and-tonic/foundation/colors'
import { spacing } from 'gin-and-tonic/foundation/spacing'

export const globalStyles = css`
  ${EINA_01_FONT}

  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  body {
    margin: ${spacing.X0};
    box-sizing: border-box;
    font-family: 'Eina 01';
    font-size: ${fontSize.X12};
    line-height: ${defaultLineHeight};
    background-color: ${colors.GRAYSCALE.X0};
  }

  input,
  button,
  submit {
    border: none;
  }

  div,
  input,
  button {
    box-sizing: border-box;
  }

  button {
    font-family: 'Eina 01';
    cursor: pointer;
    user-select: none;
  }

  a {
    text-decoration: none;
    color: ${colors.GRAYSCALE.X70};

    &:hover {
      color: ${colors.PRIMARY.DARK};
    }
  }
`
